export const SET_QUOTATION_FORM_CUSTOMER = 'QUOTATION_FORM_SET_CUSTOMER'

export const setCustomer = (customer) => {
  return {
    type: SET_QUOTATION_FORM_CUSTOMER,
    payload: customer
  }
}